// extracted by mini-css-extract-plugin
module.exports = {"jcGrey800":"#202d38","header":"LoginHeader__header","logoIcon":"LoginHeader__logoIcon"};